<script lang="ts">
    import { isMobile } from "@app/services/isMobile";
    import SimilarPhrasesContainer from "./SimilarPhrasesContainer.svelte";

    function install() {
        const searchContainer = document.querySelector<HTMLElement>(
            "#search-suggestions-container"
        );
        if (!searchContainer) {
            return;
        }
        if (isMobile() || !searchContainer.dataset["main"]) {
            return;
        }

        new SimilarPhrasesContainer({
            target: searchContainer,
        });
    }
    install();
</script>

<style>
    :global(.wordlistContainer) {
        top: 6rem;
    }
</style>
